import './MainContentAreaAll.css';
import { Link } from 'react-router-dom';
function AtAndTJobComponent(props){ 
    return(
       <div className="ExperienceMainLayout">   
       <br /> 
        <div class="card">
           <div class="card-footer" style={{height:"50px"}}>
            <span className="ExperienceCardFooter-Previous"><Link onClick={() => props.handlechange('Synechron')}>Previous</Link></span>
            <span className="ExperienceCardFooter"><Link onClick={() => props.handlechange('LabCorp')}>Next</Link></span>
           </div>
           <h5 class="card-header">AT&T-Middletown, NJ
                              <br/>May 2017 – Nov 2019
                              <br/>Full Stack.Net Developer
           </h5>    					       
           <div class="card-body">
           <h3 style={{textDecoration:"underline"}}>Roles And Responsibilities</h3>
            -Works on the website which is visible to the users and modifies the public website as per the end users.
            <br/>-Contributes on the quality delivery of the products to the client/users. 
            <br/>-Works closely with the Business Analysts in requirement gathering and design review activities.
            <br/>-Works closely with the EQA team to ensure the Quality of the Delivery.
            <br/>-Works on the MVC methodology for designing the website.
            <br/>-Maintaining the old website which is developed using classic ASP.Net pages.
            <br/>-Involving in Production release.
            <br/>-Querying SQL data queries, Stored Procedures and the views.
            <br/>-Working with the technologies like C#, jQuery and Web API.
            <br/>-Working on the Database servers which also deals with the Legacy data structure.
            <br/>-Participating in daily scrums and helps following the Agile process.
            <br/>-Working with Team Foundation Source Control TFS as the source for version control and project / issue management.
            <br/>-User Docker Container To Cicd Pipeline  For Application So Get Better Idea In  Ui Side 
            <br/>-Working on the Tickets requested by the users and other teams.
            <br/>-Maintaining good communication with the team to keep up the team spirit.
            <br/>-Coded the unit test cases for the functionalities implemented for the dynamic data from the database.
            <br/>-Participated in the Production release when the project went live for every release and worked on the severities during the release and helped for the release to go live.
            <br/>-Had a great interaction and team spirit in participating in code reviews and merging the individual codes from different branches in local into the development branch which is finally moved into the EQA.
            <br/>-Good experience in working with a huge team of over 20 people.
            <br/>-Performed unit testing on every new version before sending it for User Acceptance Test UAT.
            <br/>-Designed and created tables, views and SPs using SQL Server 2012.
            <br/>-Created and maintained database objects like complex Stored Procedures, Cursors, and Tables, Views, User Defined Functions, in SQL Server 2008 for inserting/Updating/Deleting the data into the relational tables.

         
            <h3 style={{textDecoration:"underline"}}>Environment</h3>
            Microsoft Visual Studio 2015/2013, WCF RESTFUL Service API, ASP.NET, C#, XML +  JSON, Agile and Scrum,Git,AJAX, CSHTML, MVC, CSS, Oracle11g, SQL Server 2008/2014, Windows Server 2008 R2/2008 2010..
           </div>            
         </div>
       </div>
       
)
}
export default AtAndTJobComponent